import React, {FC, useState} from 'react';
import messages from '../messages';
import quoteColumns from './columns';
import CollapseTable from 'components/collapse-table/collapse-table';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {Button} from 'reactstrap';

interface Props {}

const QuoteTable: FC<Props> = props => {
  const {t} = useTranslation();
  const {id} = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const filterDAte = [
    new Date('2015/01/01').toISOString(),
    new Date().toISOString(),
  ].join(',');

  return (
    <div>
      <Button color="light" onClick={toggle} className="mb-3 w-100">
        {t(...messages.estimate())}
      </Button>
      <CollapseTable
        isOpen={isOpen}
        columns={quoteColumns}
        url={`quotations?filter[directory_id]=${id}&limit=10&filter[created_at]=${filterDAte}&for_stats=true`}
        name="directory-quotation"
      />
    </div>
  );
};

export default QuoteTable;
